import React, { useMemo } from 'react';
import './index.scss';
import { Bubble, Button } from 'tea-component';
import SvgIcon from '@/pages/home/components/SvgIcon';
import { useIntl } from 'umi';
import { openWindowUrl } from '@/pages/opinion/utils/url';
const ShareBtn = ({ data, text = 'Go to' }: any) => {
  const { formatMessage } = useIntl();

  const disabled = useMemo(() => {
    return !data?.content_url;
  }, [data]);

  return (
    <Bubble
      dark
      closeOnScroll
      content={
        disabled
          ? formatMessage({ id: "This review don't have URL" })
          : formatMessage({ id: 'Go to original post' })
      }
    >
      <Button
        disabled={disabled}
        onClick={() => openWindowUrl(data?.content_url)}
        type="link"
        className="dbo-feeds-btn"
      >
        {text ? formatMessage({ id: text }) : ''}
        <SvgIcon type="other-share-icon" className="dbo-feeds-btn-icon" />
      </Button>
    </Bubble>
  );
};

export default ShareBtn;
